var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProperty1IconParkDocSearchTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.58325 2.49984C2.58325 1.62539 3.29213 0.916504 4.16659 0.916504H15.8333C16.7077 0.916504 17.4166 1.62539 17.4166 2.49984V11.2498C17.4166 11.6641 17.0808 11.9998 16.6666 11.9998C16.2524 11.9998 15.9166 11.6641 15.9166 11.2498V2.49984C15.9166 2.45381 15.8793 2.4165 15.8333 2.4165H4.16659C4.12056 2.4165 4.08325 2.45381 4.08325 2.49984V17.4998C4.08325 17.5459 4.12055 17.5832 4.16659 17.5832H8.74992C9.16413 17.5832 9.49992 17.919 9.49992 18.3332C9.49992 18.7474 9.16413 19.0832 8.74992 19.0832H4.16659C3.29214 19.0832 2.58325 18.3743 2.58325 17.4998V2.49984Z",
    fill: "#444444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.33325 5C6.33325 4.58579 6.66904 4.25 7.08325 4.25H12.9166C13.3308 4.25 13.6666 4.58579 13.6666 5C13.6666 5.41421 13.3308 5.75 12.9166 5.75H7.08325C6.66904 5.75 6.33325 5.41421 6.33325 5Z",
    fill: "#444444"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.33325 8.33301C6.33325 7.91879 6.66904 7.58301 7.08325 7.58301H12.9166C13.3308 7.58301 13.6666 7.91879 13.6666 8.33301C13.6666 8.74722 13.3308 9.08301 12.9166 9.08301H7.08325C6.66904 9.08301 6.33325 8.74722 6.33325 8.33301Z",
    fill: "#444444"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.33325 11.6665C6.33325 11.2523 6.66904 10.9165 7.08325 10.9165H9.58325C9.99747 10.9165 10.3333 11.2523 10.3333 11.6665C10.3333 12.0807 9.99747 12.4165 9.58325 12.4165H7.08325C6.66904 12.4165 6.33325 12.0807 6.33325 11.6665Z",
    fill: "#444444"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 15.4163C10.5 13.8515 11.7685 12.583 13.3333 12.583C14.8981 12.583 16.1667 13.8515 16.1667 15.4163C16.1667 15.9261 16.0317 16.4049 15.7959 16.8183L16.7803 17.8027C17.0732 18.0956 17.0732 18.5704 16.7803 18.8633C16.4874 19.1562 16.0126 19.1562 15.7197 18.8633L14.7352 17.8789C14.3219 18.1147 13.8431 18.2497 13.3333 18.2497C11.7685 18.2497 10.5 16.9811 10.5 15.4163ZM13.3333 14.083C12.597 14.083 12 14.68 12 15.4163C12 16.1527 12.597 16.7497 13.3333 16.7497C13.7017 16.7497 14.034 16.6013 14.2761 16.3592L14.2762 16.3591C14.5183 16.117 14.6667 15.7847 14.6667 15.4163C14.6667 14.68 14.0697 14.083 13.3333 14.083Z",
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProperty1IconParkDocSearchTwo);
export default __webpack_public_path__ + "static/media/Property 1=icon-park_doc-search-two.2401f94f0bfb9a2aeac652892ce572f8.svg";
export { ForwardRef as ReactComponent };